"use strict";

var _toConsumableArray = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sans/Downloads/the-ultimate-api-challenge-weather-react-master/sans weather app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plugins = void 0;
var plugins = [];
var interactorsInitializers = new Map();
var updatersInitializers = new Map();
var interactors = new Map();
var updaters = new Map();
var presets = new Map();
var drawers = new Map();
var pathGenerators = new Map();

var Plugins = /*#__PURE__*/function () {
  function Plugins() {
    _classCallCheck(this, Plugins);
  }

  _createClass(Plugins, null, [{
    key: "getPlugin",
    value: function getPlugin(plugin) {
      return plugins.find(function (t) {
        return t.id === plugin;
      });
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      if (!Plugins.getPlugin(plugin.id)) {
        plugins.push(plugin);
      }
    }
  }, {
    key: "getAvailablePlugins",
    value: function getAvailablePlugins(container) {
      var res = new Map();

      var _iterator = _createForOfIteratorHelper(plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;

          if (!plugin.needsPlugin(container.actualOptions)) {
            continue;
          }

          res.set(plugin.id, plugin.getPlugin(container));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return res;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, sourceOptions) {
      var _iterator2 = _createForOfIteratorHelper(plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          plugin.loadOptions(options, sourceOptions);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      return presets.get(preset);
    }
  }, {
    key: "addPreset",
    value: function addPreset(presetKey, options) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (override || !Plugins.getPreset(presetKey)) {
        presets.set(presetKey, options);
      }
    }
  }, {
    key: "addShapeDrawer",
    value: function addShapeDrawer(type, drawer) {
      if (!Plugins.getShapeDrawer(type)) {
        drawers.set(type, drawer);
      }
    }
  }, {
    key: "getShapeDrawer",
    value: function getShapeDrawer(type) {
      return drawers.get(type);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return drawers.keys();
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(type) {
      return pathGenerators.get(type);
    }
  }, {
    key: "addPathGenerator",
    value: function addPathGenerator(type, pathGenerator) {
      if (!Plugins.getPathGenerator(type)) {
        pathGenerators.set(type, pathGenerator);
      }
    }
  }, {
    key: "getInteractors",
    value: function getInteractors(container) {
      var res = interactors.get(container);

      if (!res) {
        res = _toConsumableArray(interactorsInitializers.values()).map(function (t) {
          return t(container);
        });
        interactors.set(container, res);
      }

      return res;
    }
  }, {
    key: "addInteractor",
    value: function addInteractor(name, initInteractor) {
      interactorsInitializers.set(name, initInteractor);
    }
  }, {
    key: "getUpdaters",
    value: function getUpdaters(container) {
      var res = updaters.get(container);

      if (!res) {
        res = _toConsumableArray(updatersInitializers.values()).map(function (t) {
          return t(container);
        });
        updaters.set(container, res);
      }

      return res;
    }
  }, {
    key: "addParticleUpdater",
    value: function addParticleUpdater(name, initUpdater) {
      updatersInitializers.set(name, initUpdater);
    }
  }]);

  return Plugins;
}();

exports.Plugins = Plugins;